/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Empty_HintInputs */

const vi_grower_area_camera_empty_hint = /** @type {(inputs: Grower_Area_Camera_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera lắp tại vườn sẽ hiện ở đây để theo dõi vùng trồng.`)
};

/**

* @param {Grower_Area_Camera_Empty_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_empty_hint = /** @type {((inputs?: Grower_Area_Camera_Empty_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Empty_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_empty_hint(inputs)
});